// Utilities
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

// Service
import { teamMemberService } from "../../../../../Api/Services/TeamMembers"; // Import the service for fetching attendance data

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import {
  IAttendanceServiceResponse,
  ITeamMembersAttendanceListParams,
} from "../../types";

/**
 * Async thunk to fetch team members attendance list details.
 * Dispatches an API call to retrieve the team member's attendance data.
 */
export const fetchTeamMemberAttendanceAsyncThunk = createServiceAsyncThunk<
  IAttendanceServiceResponse, // Response Type
  ITeamMembersAttendanceListParams // Payload Type
>(
  ACTION_NAMES.FETCH_TEAM_MEMBERS_ATTENDANCE,
  ({ user, activeYear, type, status }) =>
    teamMemberService.fetchTeamMemberAttendance(user, activeYear, type, status),
  ERROR_MESSAGES.TEAM_MEMBERS_ATTENDANCE_LIST_FETCH_FAILURE
);

/**
 * Slice to manage the state of team member's attendance details.
 * Includes actions to clear errors and handle async states.
 */
const teamMembersAttendanceListSlice = createGenericSlice<
  IAttendanceServiceResponse,
  ITeamMembersAttendanceListParams
>(SLICE_NAMES.TEAM_MEMBERS_ATTENDANCE, fetchTeamMemberAttendanceAsyncThunk);

// Exporting the action to reset the error state
export const { clearError: clearTeamMembersAttendanceListError } =
  teamMembersAttendanceListSlice.actions;

// Exporting the reducer to be used in the store
export default teamMembersAttendanceListSlice.reducer;
